





















































































































































import { Component, Prop } from "vue-property-decorator";
import { RadioButtonConfiguration } from "./radioButtonConfiguration";
import WidgetBase from "../WidgetBase.vue";
import randomstring from "randomstring";
import { TranslateResult } from "vue-i18n";
import BarChart from "./barChart";
import { ChartData, ChartOptions } from "chart.js";
import AnimatedCheckmark from "../../customActions/AnimatedCheckmark.vue";

@Component({ components: { "bar-chart": BarChart, AnimatedCheckmark } })
export default class RadioButtonWidget extends WidgetBase<
    RadioButtonConfiguration
> {
    @Prop() widgetHeight!: number;

    public newOption: string = "";
    public valid: boolean = false;
    public previewMode: boolean = false;
    public selectedItem: number = 0;
    public answers: [] = [];
    public surveyActive: boolean = true;

    public togglePreview() {
        this.previewMode = !this.previewMode;
    }

    public static get type() {
        return "radio";
    }

    public static get thumbnailAsset() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        return require("@/assets/widget-thumbnails/completed-task.svg");
    }

    public get isPresenter(): boolean {
        if (!this.$store.state.studio && this.$store.state.user) {
            return true;
        } else {
            return this.$store.getters.isPresenter;
        }
    }
    public get form(): Vue & { resetValidation: () => boolean } {
        return this.$refs.form as Vue & { resetValidation: () => boolean };
    }

    public get rules(): { [key: string]: (v: string) => boolean | string } {
        return {
            required: v => !!v || "Required.",
            notEmpty: v => v.length > 0 || "Message too short",
        };
    }
    public get questions() {
        this.surveyActive = true;
        return this.config.state.questions ?? [];
    }

    public set questions(newValue) {
        //
    }

    public get previewBtnLabel(): TranslateResult {
        if (this.previewMode) {
            return this.$t("widget.radio.previewBtnLabelStop");
        } else {
            return this.$t("widget.radio.previewBtnLabel");
        }
    }

    public get showResults(): boolean {
        return this.config.state.showResults ?? false;
    }

    public set showResults(newValue) {
        this.config.state.showResults = newValue;
        this.update({
            config: this.config,
            payload: { showResults: this.showResults },
        });
    }

    public get answerButtonActive(): boolean {
        return this.config.state.answerButtonActive ?? true;
    }

    public set answerButtonActive(newValue) {
        this.config.state.answerButtonActive = newValue;
        this.update({
            config: this.config,
            payload: { answerButtonActive: this.answerButtonActive },
        });
    }

    public addQuestion() {
        this.questions.push({
            answer: this.newOption,
            checked: false,
            id: randomstring.generate(),
        });
        this.newOption = "";
        this.update({
            config: this.config,
            payload: { questions: this.questions },
        });
        this.form.resetValidation();
    }

    public deleteQuestion(index: number) {
        this.questions.splice(index, 1);
        this.update({
            config: this.config,
            payload: { questions: this.questions },
        });
    }

    public giveAnswers() {
        if (this.answers == null) {
            this.answers = [];
        }
        this.update({
            config: this.config,
            payload: { answers: this.answers },
        });
    }

    public handleItemHover(index: number) {
        this.selectedItem = index;
    }

    public get renderChart(): boolean {
        if (Object.keys(this.config.state.report.chart).length > 0) {
            return true;
        } else {
            return false;
        }
    }

    public get chartData(): { data: ChartData; options: ChartOptions } {
        const dataFromStore: { [key: number]: number } = this.config.state
            .report.chart;

        return {
            data: {
                labels: Object.keys(dataFromStore),
                datasets: [
                    {
                        data: Object.values(dataFromStore),
                    },
                ],
            },
            options: {
                tooltips: {
                    // callbacks: {
                    //     title: function(tooltipItems, data) {
                    //         return data.labels[tooltipItems[0].index];
                    //     },
                    // },
                    position: "cursor",
                },
                legend: { display: false },
                responsive: true,
                scales: {
                    yAxes: [
                        {
                            display: false,
                            ticks: { beginAtZero: true, stepSize: 1 },
                            gridLines: { display: false },
                        },
                    ],
                    xAxes: [{ gridLines: { display: false } }],
                },
            },
        };
    }
    public submitHandler() {
        this.surveyActive = false;
        this.$store.commit("showSnackbar", {
            text: this.$t("widget.radio.answerSaved"),
            color: "success",
        });
    }
}
